import axios from "@/api/index";
let method = 'GET';
/*获取房间号的离线消息*/
export const getOfflineMessagesList=data=>axios.post('/home/rest/message/getOfflineMessagesList',data)
/*私聊获取房间号*/
export const privateLetter=data=>axios.post('/home/rest/message/privateLetter',data)
/*好友搜索*/
export const msgFriendSearch=data=>axios.post('/home/rest/message/msgFriendSearch',data)
/*聊天历史记录*/
export const msgChatLog=data=>axios.post('/home/rest/message/msgChatLog',data)
/*获取离线消息房间号列表*/
export const getOfflineMessagesForRoom=data=>axios.post('/home/rest/message/getOfflineMessagesForRoom',data)
/*当前聊天对象列表*/
export const msgCurrentRoomList=data=>axios.post('/home/rest/message/msgCurrentRoomList',data)
/*将离线消息置为已读*/
export const makeOfflineMessagesRead=data=>axios.post('/home/rest/message/makeOfflineMessagesRead',data)